import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { FeatureToggleState } from '../types';

/**
 * Redux slice for feature toggle preference
 * Stores user's version preference per feature, per user (via scoped persistence)
 */
interface FeatureToggleSliceState {
  features: Record<string, FeatureToggleState>;
}

const initialState: FeatureToggleSliceState = {
  features: {},
};

export const featureToggleSlice = createSlice({
  name: 'featureRolloutToggle/preference',
  initialState,
  reducers: {
    setPreference: (
      state,
      action: PayloadAction<{ featureKey: string; preference: 'new' | 'classic' }>,
    ) => {
      const { featureKey, preference } = action.payload;
      const existing = state.features[featureKey];
      state.features[featureKey] = {
        preference,
        isGraduated: existing?.isGraduated ?? false,
      };
    },

    graduate: (state, action: PayloadAction<{ featureKey: string }>) => {
      const { featureKey } = action.payload;
      const existing = state.features[featureKey];
      state.features[featureKey] = {
        preference: existing?.preference ?? null,
        isGraduated: true,
      };
    },

    clearPreference: (state, action: PayloadAction<{ featureKey: string }>) => {
      const { featureKey } = action.payload;
      // Delete the feature preference (Immer handles this correctly)
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state.features[featureKey];
    },
  },
});

export const { setPreference, clearPreference, graduate } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;
